import {addLoader} from '../common/Utils';

class PJax {
    constructor() {
        this.init();
    }

    init() {
        this.addLoader();
    }

    addLoader(){
        $(document).on('pjax:beforeSend', data => {
            const $target = $(data.target);
            const isContainer = $target.attr('data-pjax-container');
            if (typeof isContainer !== "undefined") {
                addLoader(data.target);
            }
        });
    }

}

export default PJax;



// WEBPACK FOOTER //
// ./src/assets/js/components/PJax.js